// extracted by mini-css-extract-plugin
export var avatarContainer = "_58-1";
export var largeAvatarContainer = "_58-2";
export var smallAvatarContainer = "_58-0";